
import { getSecurityFeatures } from '~/fc/Dal/SecurityFeaturesRepo';

export default {
    name: "SecurityAndCompliancePage",
    components: {
        // TrustPilotReviews: () => import(/* webpackChunkName: "Accordion" */ "~/components/ui/TrustPilotReviews"),
    },
    async asyncData(ctx) {
        const features = await getSecurityFeatures(ctx);
        const params = { type: "pricing" };
        if (ctx.app.i18n && ctx.app.i18n.locale) params.lang = ctx.app.i18n.locale;
        const { data: reviews } = await ctx.$axios.get(process.env.QUERY_SERVICE + "/view/reviews/", { params });
        
        const technology = features.filter(feature => feature.type === 'technology');
        const practices = features.filter(feature => feature.type === 'practices');

        return { technology, practices, reviews };
    },
    mounted() {
        this.$store.commit('updateBreadcrumbs', [
            {
                url: this.localePath('/security-and-compliance'),
                label: this.$t('security_and_compliance')
            }
        ])
    }
}
